import { create } from 'zustand';
import { createFilterSlice, FilterStore } from '@/lib/slices/filter';
import { createSharedSlice, SharedStore } from '@/lib/slices/shared';
import { createSettingSlice, SettingStore, initialSettings } from '@/lib/slices/settings';
import { createSearchSlice, SearchStore } from '@/lib/slices/search';
import { createPrintSettingsSlice, PrintSettingsStore } from '@/lib/slices/print-settings';
import { persist } from 'zustand/middleware';
export const CALENDAR_STORAGE_KEY = 'calendar-storage';

export type CalendarStore = SettingStore & FilterStore & SearchStore & SharedStore & PrintSettingsStore;
export const initialCalendarView = 'resources';

export const serializeCalendarStore = (state: CalendarStore) => {
  delete state.calRef;
  return {
    state: {
      ...state,
      expanded: state.expanded ? Array.from(state.expanded.entries()) : [],
      cursors: [],
      editEventObject: undefined,
    },
  };
};

export const deserializeCalendarStore = (stateToParse: string) => {
  const state = JSON.parse(stateToParse!).state;
  return {
    state: {
      ...state,
      // Merge stored settings with initialSettings to ensure new settings have defaults
      settings: {
        ...initialSettings,
        ...state.settings,
      },
      expanded: new Map(state.expanded),
      cursors: [],
      editEventObject: undefined,
    },
  };
};

export const useCalendarStore = create<CalendarStore, [['zustand/persist', CalendarStore]]>(
  persist(
    (...a) => ({
      ...createSettingSlice(...a),
      ...createFilterSlice(...a),
      ...createSearchSlice(...a),
      ...createPrintSettingsSlice(...a),
      ...createSharedSlice(...a), //Should be last
    }),
    {
      name: CALENDAR_STORAGE_KEY,
      storage: {
        getItem: (name) => {
          const str = localStorage.getItem(name + window.location.pathname);
          return deserializeCalendarStore(str!);
        },
        setItem: (name, newValue) => {
          localStorage.setItem(
            name + window.location.pathname,
            JSON.stringify(serializeCalendarStore(newValue.state)),
          );
        },
        removeItem: (name) => localStorage.removeItem(name + window.location.pathname),
      },
    },
  ),
);
